import { useEffect, useState } from 'react'

import * as Styled from './styled'
import { SxProps, Theme } from '@mui/material'

interface AvatarProps {
  name: string
  className?: string
  size?: 'sm' | 'xs' | 'xxs' | number
  colored?: boolean
  asGroup?: boolean
  img?: string
  emptyPic?: string
  color?: string
  sx?: SxProps<Theme>
}

export default function Avatar(props: AvatarProps) {
  const [innerImg, onInnerImg] = useState(props.img)

  useEffect(() => {
    onInnerImg(props.img)
  }, [props.img])
  return (
    <Styled.Avatar
      className={props.className}
      data-size={props.size}
      data-colored={props.color && true}
      data-asgroup={props.asGroup}
      {...(props.color && { style: { backgroundColor: props.color } })}
      sx={{ ...props.sx }}
    >
      {innerImg && innerImg.length > 0 ? (
        <img
          src={innerImg}
          alt={props.emptyPic}
          onError={() => onInnerImg(props.emptyPic)}
        />
      ) : props.asGroup ? (
        <img src={props.emptyPic} />
      ) : (
        <div style={{ paddingBottom: '1px' }}>{getSymbols(props.name)}</div>
      )}
    </Styled.Avatar>
  )
}

function getSymbols(name: string) {
  return name[0]?.toUpperCase()
}
